export const needsSetup=[
    "Line Chart",
    "Radar Chart",
    "Overview Widget",
    "Total Value Widget", //done
    "Performance Widget", //done --need testing
    "Current Status Widget", //done --need testing
    "Performance Device Listed", //done  --need testing
    "Room State Widget",

// some total value widgets have this name
    "Solar Widget (Total)",
    'Solar Widget',
    'Cost Saved Widget',
    'Carbon Avoid Widget',
    'Standard Coal Saved Widget',
    'Potential Rec Earn Widget',
    'Equivalent Trees Planted Widget',
]


const onlySetupTitle = ["Net Zero Widget","Circle Device Status Widget"];

const doesNotNeedSetup = [
    "Weather Widget",
    // "Circle Device Status Widget",
    "Time Circle Widget",
    // "Net Zero Widget",
    "Plant Detail Widget",
    "Weather AQI Widget",
    "Plant Location Widget",
    "Battery Widget",
    "Islanding Widget",
    "Static Map Device Widget",
    "Event Log Widget",
    
]

const hasEditSetup=[
  "Line Chart V2",
  'Chiller Widget',
//   'Room State Widget',
  'Chiller_1A Widget',
//   'Overview Widget',   --- need to fix the icon
  'Line Chart',
  'Radar Chart',
  'Radar Chart Widget', 
  
  // 'Current Status Widget',
  'Performance Device Listed',
  'Battery Alarm Widget',
  'Rectifier Widget',
  'Circle Device Status Widget', 
  'Net Zero Widget', 
  'Single Device Widget',
  'Performance Widget',
  'Gas Widget',
  'Total Value Widget',
  'Solar Widget (Total)',
  'Solar Widget',
  'Cost Saved Widget',
  'Carbon Avoid Widget',
  'Standard Coal Saved Widget',
  'Potential Rec Earn Widget',
  'Equivalent Trees Planted Widget'
]


export {doesNotNeedSetup, hasEditSetup, onlySetupTitle}